import React from 'react';
import { Card, Row, Col } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import LoggedLayout from '../../components/Layouts/LoggedLayout';
import _s from './index.less';
import { pluralize } from '../../utils';

const AdminCard = ({ prefix, title, description }) => {
  return (
    <Col span={24} lg={6}>
      <Card
        cover={
          <div className={_s.image}>
            <img alt={prefix} src={`/public/images/${prefix}_logo.png`} className={_s.img} />
          </div>
        }
        className={_s.card}
        actions={[
          <Link key="setting-action" to={`/admin/${pluralize(prefix)}`}>
            <SettingOutlined key="setting"></SettingOutlined>
          </Link>
        ]}
      >
        <Card.Meta title={title} description={description} />
      </Card>
    </Col>
  );
};

const AdminPage = () => (
  <LoggedLayout>
    <Row gutter={[16, 16]} style={{ width: '100%' }}>
      <AdminCard
        prefix="contractor"
        title="Contractors"
        description="Сhange or add a new contrator"
      />
      <AdminCard prefix="plan" title="Plans" description="Сhange or add a new plan" />
      <AdminCard
        prefix="products-of-configurator"
        title="All products"
        description="Products list from actual configurators"
      />
      <AdminCard prefix="assistant-сhat" title="Assistant Chats" description="Chat history" />
      <AdminCard prefix="user" title="Users" description="" />
      <AdminCard prefix="plans-list" title="Plans List" description="" />
      <AdminCard prefix="generation" title="Generations" description="flux" />
      <AdminCard prefix="directory" title="Directories" description="" />
    </Row>
  </LoggedLayout>
);

export default AdminPage;
